const selectForm = document.querySelectorAll<HTMLSelectElement>("select");
if(selectForm) {
  selectForm.forEach((sel) => {
    sel.addEventListener("change", ()=>{
      changeSelectColor(sel); 
    })
    window.addEventListener("load", ()=> {
      changeSelectColor(sel);
    })
  })
}

export const changeSelectColor = (sel: HTMLSelectElement) => {
  const unselected: string = "未選択";
  let val: string = sel.value;
  if (val === unselected) {
    sel.classList.remove("c-input--select--selected");
  } else {
    sel.classList.add("c-input--select--selected");
  }
}
